// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IPackHistoryItem from "./IPackHistoryItem";

export default interface IPackHistory {
  packs: IPackHistoryItem[];
}
